import { subscribeToArray } from '../observable/from';
import { Observable } from '../Observable';
import { createOperatorSubscriber } from '../operators/OperatorSubscriber';
export function endWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return function (source) {
        return new Observable(function (subscriber) {
            source.subscribe(createOperatorSubscriber(subscriber, undefined, function () {
                subscribeToArray(values, subscriber);
            }));
        });
    };
}
//# sourceMappingURL=endWith.js.map